export default __webpack_public_path__ + "static/media/Tasks-Typescript.e0f11541.png";